import { render, staticRenderFns } from "./MyProfileComponent.vue?vue&type=template&id=5ab0b07c&"
import script from "./MyProfileComponent.vue?vue&type=script&lang=js&"
export * from "./MyProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports